module.exports = __webpack_public_path__ + "img/Kosmetik-og-personlig-pleje.9091fc54.jpg";